import { render } from "./ClientApp.vue?vue&type=template&id=04a5e962"
import script from "./ClientApp.vue?vue&type=script&lang=js"
export * from "./ClientApp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/ClientApp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04a5e962"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04a5e962', __exports__)) {
    api.reload('04a5e962', __exports__)
  }
  
  module.hot.accept("./ClientApp.vue?vue&type=template&id=04a5e962", () => {
    api.rerender('04a5e962', render)
  })

}


export default __exports__